export enum VALID_ROUTES {
  HOME = 'home',
  INTAKE_APLICATION = 'intake-application',
  LOGIN = 'login',
  FORGET_PASSWORD = 'login/forget-password',
  SET_PASSWORD = 'set-password',
  LOGOUT = 'logout',
  ACCOUNT = 'account',
  PROFILE = 'profile',
  LEADERS = 'leaders',
  USERS_MANAGMENT = 'users-management',
  PLASTUNY_MANAGMENT = 'plastuny-management',
  SKHODYNY = 'skhodyny',
  ATTANDANCE = 'attendance',
  CONTACT_US = 'contact-us',
  DONATE = 'donate',
  MAKE_PAYMENT = 'make-payment',
  PAYMENTS = 'payments',
  MY_PAYMENTS = 'my-payments',
  DEV_TEST = 'dev-test',
}
